import React, {useEffect, useState} from 'react';
import './styles.css';

import logo from '../../assets/images/logo3.svg';
import trophy from '../../assets/images/trophy.svg';
import pin from '../../assets/images/pin.svg';
import user from '../../assets/images/user.svg';
import suitcase from '../../assets/images/suitcase.svg';
import star from '../../assets/images/star.svg';
import medal from '../../assets/images/medal.svg';
import menu from '../../assets/images/menu.svg';
import calendar from '../../assets/images/calendar9.svg';
import talk from '../../assets/images/talk3.svg';
import vv from '../../assets/images/visita-virtual.svg';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';

import getUserInfo from "../../services/getUserInfo";


export const Sidebar = () => {
  const [showMenu, setShowMenu] = useState(false);

  const [userInfo, setUserInfo] = useState({});
  const [userCanSeeVGV, setUserCanSeeVGV] = useState(true);

  const { pathname } = useLocation();
  const noshow = ['/', '/login', '/recovery-password'];

  useEffect(() => {
    if(!noshow.includes(pathname)){
      getUserInfo().then(user => {
        setUserInfo(user);
        // setUserCanSeeVGV(user.isDiretor || user.isMaster || user.isSuperintendente);
      });
    }
  }, []);

  return (
    <>
      {!noshow.includes(pathname) &&
        <div id="sidebar">
          <div className="sidebar-header">
            <img src={logo} className="logo" alt="Cury" />
            <h3>Dashboard 2.0</h3>
            <button className="btn-toggle-menu" onClick={() => setShowMenu(!showMenu)}><img src={menu} /></button>
            {/* <hr /> */}
          </div>
          <div className={`sidebar-body${showMenu ? ' open' : ' closed'}`}>
            <ul className="menu">
              <li><NavLink onClick={() => setShowMenu(false)} to="/sales"><img src={trophy} />Vendas {false && <div className="tag-sidebar"><p>Beta</p></div>}</NavLink></li>
              <li><NavLink onClick={() => setShowMenu(false)} to="/shifts"><img src={pin} /> Plantões</NavLink></li>
              <li><NavLink onClick={() => setShowMenu(false)} to="/leads"><img src={vv} style={{marginRight: 14, width: 20, height: 20, marginLeft: -2}} /> Visita Virtual</NavLink></li>
              <li><NavLink onClick={() => setShowMenu(false)} to="/agendamentos"><img src={calendar} style={{width: 24, height: 24, marginLeft: -4, marginRight: 12}} /> Agendamentos</NavLink></li>
              <li><NavLink onClick={() => setShowMenu(false)} to="/brokers"><img src={user} /> Corretores</NavLink></li>

              {!userInfo.isGerente &&
              <li><NavLink onClick={() => setShowMenu(false)} to="/managers"><img src={suitcase}/> Gerentes</NavLink>
              </li>
              }

              {(userInfo.isDiretor || userInfo.isUserEspecial) &&
              <li><NavLink onClick={() => setShowMenu(false)} to="/super"><img src={star}/> Superintendentes</NavLink>
              </li>
              }

              {userInfo.isUserEspecial &&
              <li><NavLink onClick={() => setShowMenu(false)} to="/directors"><img src={medal}/> Diretores</NavLink>
              </li>
              }
            </ul>
          </div>
        </div>
      }
    </>
  );

}

export default Sidebar;